module.exports = __webpack_public_path__ + "img/2-ancho.589669af.jpg";